function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.recalcularicon{fill:#517ed2;}\r\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_x34_n3yfZ.tif"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "recalcularicon",
  d: "M3.4,12.5c.3,0,.7,0,.6.4s-1.3,1.4-1.5,1.4c-.1,0-.2,0-.2,0-.1,0-1.3-1.3-1.3-1.4-.1-.5.6-.4.7-.4s.2-.6.3-.8c.4-.8,1.2-1.5,2.1-1.7s2-.2,1.6.4-.6.2-.8.3c-.7.3-1.2,1-1.4,1.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "recalcularicon",
  d: "M5.8,13.2c-.3,0-.7,0-.6-.4s1.3-1.4,1.5-1.4c.3,0,1.4,1.1,1.5,1.3.2.6-.5.4-.7.6s-.2.6-.3.8c-.6,1.1-1.8,1.9-3.1,1.7s-.6,0-.5-.4.7-.3,1-.5c.6-.3,1.1-1,1.3-1.7Z"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "recalcularicon",
  d: "M18.1,0H4.8c-.4.2-.9.5-1,.9v7.4c-5.2.9-5.1,8-.1,9,0,1,0,2,1.1,2.4.8.3,2.7,0,3.6,0,2.8,0,6.1.3,8.9,0,.9,0,1.5-.3,1.7-1.1V1.4c0-.7-.3-1.2-1-1.4ZM3.9,8.9c4.5-.6,5.8,4.4,3.6,6.7-.4.5-1,.8-1.8,1-.3,0-.6.1-.9.1-5.1.3-5.6-7.3-.9-7.9ZM18.5,19c-.2.3-.8.2-1,.2-.6,0-1.2,0-1.8,0-.8,0-1.7,0-2.5,0h-2.8c-.9,0-1.7,0-2.6,0-.6,0-1.3,0-1.9,0-.2,0-.5,0-.7,0-.9-.2-.7-1-.7-1.8.5,0,.9-.1,1.2-.2,1.1-.3,1.8-.8,2.3-1.3.6-.6.8-1.2.9-1.4,1.2-3.1-1.1-6.3-4.4-6.3V1.2c0-.3.2-.4.4-.5h12.9c.4,0,.6.1.7.4,0,0,0,0,0,0,0,.2,0,.5,0,.7,0,.5,0,1.1,0,1.6,0,.8,0,1.5,0,2.3,0,.9,0,1.8,0,2.6,0,.9,0,1.9,0,2.8,0,.9.2,7.5,0,7.8Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "recalcularicon",
  d: "M17.1,12.6h-1.4c-.2,0-.4.2-.4.4v4.3s0,0,0,0c0,0,0,0,0,.1,0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,0c0,0,0,0,.1,0s.1,0,.2,0h1.4c0,0,.1,0,.2,0,0,0,.1,0,.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0v-4.3c0-.2-.2-.4-.4-.4Z"
});

var SvgRecalcular = function SvgRecalcular(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Recalcular",
    viewBox: "0 0 19.2 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("rect", {
    x: 5.7,
    y: 1.6,
    width: 11.9,
    height: 3.8,
    rx: 1.3,
    ry: 1.3,
    style: {
      fill: "#517ed2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.7,
    y: 6.3,
    width: 2.3,
    height: 2,
    rx: 0.7,
    ry: 0.7,
    style: {
      fill: "#517ed2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 6.3,
    width: 2.3,
    height: 2,
    rx: 0.7,
    ry: 0.7,
    style: {
      fill: "#517ed2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 6.3,
    width: 2.3,
    height: 2,
    rx: 0.7,
    ry: 0.7,
    style: {
      fill: "#517ed2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 9.4,
    width: 2.3,
    height: 2,
    rx: 0.7,
    ry: 0.7,
    style: {
      fill: "#517ed2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 9.4,
    width: 2.3,
    height: 2,
    rx: 0.7,
    ry: 0.7,
    style: {
      fill: "#517ed2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.4,
    y: 12.6,
    width: 2.3,
    height: 2,
    rx: 0.7,
    ry: 0.7,
    style: {
      fill: "#517ed2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.1,17.7h1.4c.2,0,.4-.2.4-.4v-1.1c0,0,0-.1,0-.2-.5.5-1.2,1-2.3,1.3h0c0,.3.2.5.4.5Z",
    style: {
      fill: "#517ed2"
    }
  }), _ref4), /*#__PURE__*/React.createElement("rect", {
    className: "recalcularicon",
    x: 10.4,
    y: 15.7,
    width: 2.3,
    height: 2,
    rx: 0.7,
    ry: 0.7,
    style: {
      fill: "#517ed2"
    }
  }), _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecalcular, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recalcular.eda854b8.svg";
export { ForwardRef as ReactComponent };